import * as React from 'react';
import {Icon} from 'antd';
import './style.less';
import i18next from "i18next";

export default function Empty() {
  return <div className="m-empty">
    <Icon type="frown" />
    <span>{i18next.t('lang276')}</span>
  </div>;
}
